import { thejamsilFont } from 'src/styles/font';
import { rem } from 'src/styles/function';
import styled from 'styled-components';

/**
 * @name 전단 공유 팝업 스타일 컴포넌트
 */
export const StyledLeafletSharePopup = styled.section`
  @media screen and (min-width: 740px) {
    width: 410px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  position: relative;
  .close_btn {
    position: absolute;
    width: ${rem(40)};
    height: ${rem(40)};
    top: ${rem(-60)};
    left: 45%;
    img {
      width: 100%;
    }
  }
  .card_header {
    padding-top: ${rem(20)};
    div {
      margin: auto;
      width: ${rem(110)};
      height: ${rem(5)};
      border-radius: ${rem(10)};
      background-color: #666666;
    }
  }
  .card_box {
    padding: ${rem(0)} ${rem(20)} ${rem(20)};
    box-sizing: border-box;
    h2 {
      ${thejamsilFont('bold')};
      font-size: ${rem(20)};
      color: #000;
      margin-bottom: ${rem(20)};
    }
    ul {
      display: flex;
      justify-content: space-around;
      li {
        width: 20%;
        img {
          width: 100%;
        }
        p {
          ${thejamsilFont('regular')}
          font-size: ${rem(14)};
          text-align: center;
          padding-top: ${rem(10)};
        }
      }
    }
  }
`;
